import { Container, Stack, Title, Text, Divider, useMantineTheme } from "@mantine/core";
import React from "react";
import Seo from "../seo/Seo";

function PrivacyPolicy() {
  const theme = useMantineTheme();
  return (
    <Container size="md" py={40}>
      <Stack gap={30}>
        <Seo
          title="Privacy Policy | SubjectBuddy"
          description="Review the SubjectBuddy privacy policy covering contact details, analytics, cookies, and data protection."
          path="/privacy-policy"
        />
        <Title
          order={1}
          style={{
            color: theme.colors.green[7],
            fontFamily: theme.headings.fontFamily,
            fontWeight: 800,
            textAlign: "center",
          }}
        >
          Privacy Policy
        </Title>
        <Text size="md" c="dimmed">
          Last updated: July 4, 2025
        </Text>
        <Divider my={10} />
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          1. Introduction
        </Text>
        <Text>
          SubjectBuddy ("we", "us", or "our") is committed to protecting your
          privacy. This Privacy Policy explains how we collect, use, disclose,
          and safeguard your information when you use our website and services.
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          2. Information We Collect
        </Text>
        <Text>
          We may collect personal information you provide directly (such as your
          name, email, phone number, and academic details) and information
          automatically collected through cookies and analytics tools.
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          3. How We Use Your Information
        </Text>
        <Text>
          We use your information to:
          <ul>
            <li>Provide and improve our academic mentorship services</li>
            <li>Communicate with you about your requests and updates</li>
            <li>
              Send you study tips, offers, and learning hacks (if opted in)
            </li>
            <li>Ensure the security and integrity of our platform</li>
          </ul>
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          4. Data Sharing & Disclosure
        </Text>
        <Text>
          We do not sell or rent your personal information. We may share your
          data with trusted partners for service delivery (e.g., email,
          analytics) and as required by law.
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          5. Data Security
        </Text>
        <Text>
          We implement industry-standard security measures to protect your data.
          However, no method of transmission over the Internet is 100% secure.
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          6. Your Rights
        </Text>
        <Text>
          You may request access, correction, or deletion of your personal data
          by contacting us at [Your email].
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          7. Cookies & Analytics
        </Text>
        <Text>
          We use cookies and analytics tools to enhance your experience and
          monitor website usage. You can control cookies through your browser
          settings.
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          8. Children's Privacy
        </Text>
        <Text>
          Our services are not intended for children under 13. We do not
          knowingly collect data from children under 13.
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          9. Changes to This Policy
        </Text>
        <Text>
          We may update this Privacy Policy from time to time. Changes will be
          posted on this page with the updated date.
        </Text>
        <Text size="lg" fw={600} style={{ color: theme.colors.green[8] }}>
          10. Contact Us
        </Text>
        <Text>
          If you have questions about this Privacy Policy, contact us at [Your
          email].
        </Text>
        <Divider my={20} />
        <Title
          order={2}
          style={{
            color: theme.colors.red[7],
            fontFamily: theme.headings.fontFamily,
            fontWeight: 700,
            textAlign: "center",
          }}
        >
          Safety Disclaimer
        </Title>
        <Text>
          SubjectBuddy is a mentorship platform. We do not create, write, or
          submit work on behalf of students. Our role is to guide, support, and
          mentor students to understand their academic tasks.
          <br />
          <br />
          All actions taken using SubjectBuddy’s guidance are the responsibility
          of the user. SubjectBuddy is not liable for any academic,
          institutional, or disciplinary consequences arising from misuse of the
          mentorship or guidance provided. Users are expected to comply with
          their own institution’s academic integrity policies.
        </Text>
      </Stack>
    </Container>
  );
}

export default PrivacyPolicy;
